import { METRIC_THRESHOLDS } from "@/constants/index"
import { getAppInsights } from "@/utils/appInsights"

const getUserAgentDeviceType = () => {
  const uad = navigator.userAgentData
  if (!uad) return null // fall back below if null

  // uad.mobile -> true on phones (Chromium); platform -> "Android", "Windows", "Chrome OS", etc.
  const isMobile = !!uad.mobile
  const platform = uad.platform || "unknown"

  return { isMobile, platform }
}

const getWebVitalRating = (metric = {}) => {
  const { name = "", value = 0 } = metric

  const limits = METRIC_THRESHOLDS[name]

  if (!limits) return "unknown"

  const [goodLimit, needsImprovementLimit] = limits
  if (value <= goodLimit) return "good"
  if (value <= needsImprovementLimit) return "needs-improvement"
  return "poor"
}

const trackWebVital = (metric = {}) => {
  const { location: { href: url = "", pathname = "" } = {} } = window
  const rating = getWebVitalRating(metric)
  const appInsightsInst = getAppInsights()

  if (!appInsightsInst) return

  const deviceType = getUserAgentDeviceType()

  const webVitalsInfo = {
    ...metric,
    rating,
    url,
    path: pathname,
    navigationType:
      performance.getEntriesByType("navigation")[0]?.type || "navigate",
    deviceType,
  }

  appInsightsInst.trackMetric({
    name: `Web Vitals - ${metric.name}`,
    average: metric.value,
    properties: {
      ...webVitalsInfo,
    },
  })
}

export { trackWebVital }
